/**
 * DerivedField — the picker for a `deployInput.deriveFrom` field.
 *
 * A derived field (e.g. flaky-test-fixer's `circleProjectSlug`, derived
 * from `repoUrl`) is NOT entered by the user — the backend resolves it
 * from another field at deploy time. So we render a read-only hint
 * instead of an input and the section sends NO value for it.
 *
 * Receives the uniform picker props bag (see deployInputSources.js); we
 * use only `deployInput` (for the help text + the source field name).
 */

import React from 'react';
import { IonIcon } from '@ionic/react';
import { sparklesOutline } from 'ionicons/icons';

export default function DerivedField({ deployInput }) {
  const from = deployInput?.deriveFrom;
  const help = deployInput?.help
    || (from
      ? `Resolved automatically from the ${from} you pick.`
      : 'Resolved automatically at deploy.');
  return (
    <div className="deploy-input-derived" aria-readonly="true">
      <IonIcon icon={sparklesOutline} aria-hidden="true" />
      <span className="deploy-input-derived-text">{help}</span>
    </div>
  );
}
